import { Component, Input, OnInit } from '@angular/core';
import { PageBreadcrumbService } from './page-breadcrumb.service';

@Component({
  selector: 'app-page-breadcrumb',
  templateUrl: './page-breadcrumb.component.html',
  styleUrls: ['./page-breadcrumb.component.scss']
})
export class PageBreadcrumbComponent implements OnInit {

  breadcrumbList: any;


  constructor(
    private breadcrumbService: PageBreadcrumbService
  ) { }

  ngOnInit(): void {
    this.breadcrumbList = this.breadcrumbService.getList();
  }

}
